module.exports = __webpack_public_path__ + "img/flux360-Tutorial_scroll2.4e112889.svg";